import { GestureOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { useQuery } from '@apollo/client/react';

import { graphql, type DocumentType } from '@/gql';
import { useMutation } from '@/hooks/mutationWithSnackbar';

const SIGN_FILE_MUTATION = graphql(`
  mutation SignFile($data: SignFileInput) {
    signFile(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

const SIGN_FILE_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment signFileMenuItemFileFields on File {
    ...fileFields
  }
`);

const SIGN_FILE_MENU_ITEM_QUERY = graphql(`
  query SignFileMenuItem {
    currentUser {
      ...basicUserFields
    }
  }
`);

interface Props {
  file: DocumentType<typeof SIGN_FILE_MENU_ITEM_FILE_FRAGMENT>;
  onClose: () => void;
}

export const SignFileMenuItem = ({ file, onClose }: Props) => {
  const { _id: fileId, filename, signatures } = file;

  const { data } = useQuery(SIGN_FILE_MENU_ITEM_QUERY);

  const { currentUser } = data ?? {};

  const [signFile] = useMutation(SIGN_FILE_MUTATION, {
    errorMessage: `Couldn't mark "${filename}" as signed`,
    optimisticResponse: {
      signFile: {
        __typename: 'SignFileResult',
        file: {
          ...file,
          signatures: [
            ...(signatures ?? []),
            {
              __typename: 'FileSignature',
              _id: 'temp',
              created: new Date().toISOString(),
              userCanUnsign: true,
              signedBy: {
                __typename: 'User',
                _id: currentUser?._id ?? 'temp',
                firstName: currentUser?.firstName ?? 'Current',
                lastName: currentUser?.lastName ?? 'User',
              },
            },
          ],
        },
      },
    },
  });

  return (
    <MenuItem
      onClick={() => {
        onClose();
        signFile({
          variables: { data: { file: fileId, version: file.signingVersion } },
        });
      }}
    >
      <ListItemIcon>
        <GestureOutlined />
      </ListItemIcon>
      <ListItemText primary="Mark as signed" />
    </MenuItem>
  );
};
